import React from 'react';

import { classNames } from '../../utils/style';
import { DefaultBsComponent } from '../../types/module';
import { textCaption } from '../../styles/typography';

export interface AuthorReadingTimeType extends DefaultBsComponent {
  locale?: 'fr' | 'en' | 'es';
  timeSecond?: number;
}

export const AuthorReadingTime = ({
  timeSecond,
  locale,
  className,
  as: Component = 'div',
  ...props
}: AuthorReadingTimeType) => {
  return (
    <Component
      {...props}
      className={classNames(
        'AuthorReadingTime',
        className,
        textCaption,
        'text-neutral-101 whitespace-nowrap',
      )}
    >
      {timeSecond ? `${Math.ceil(timeSecond / 60)} ${timeSecond > 119 ? 'mins' : 'min'}` : ''}
    </Component>
  );
};
